import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import FirstFlow from 'components/Flows/FirstFlows/FirstFlows';
import FirstAnalysisDrawer from 'components/Analyses/FirstAnalyses/Drawer/Drawer';

const FirstFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <FirstAnalysisDrawer />
      <FirstFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FirstFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);